import { render, staticRenderFns } from "./GraphDetail20.vue?vue&type=template&id=53dc6210&scoped=true&"
import script from "./GraphDetail20.vue?vue&type=script&lang=js&"
export * from "./GraphDetail20.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "53dc6210",
  null
  
)

export default component.exports